module.exports = __webpack_public_path__ + "static/media/gear-animation-2.761c687f.svg";